export default "__VITE_ASSET__DbaI2Xvn__"